import * as actionType from "./actionTypes";
import { createReducer, updateObject } from "../../utils/reducerUtils";

/* State shape same as initial state
*/
const initialState = {
  //null until loaded
  products: null,
  productsBySku: {},
  //{ fee, freeFrom } - the delivery charge the checkout will add
  delivery: null,
  orderStatus: null,
  //The Derma 2.0® cards for visitors (no prices), null until loaded
  dermaPreview: null,
};

const setProducts = (state, action) => (
  updateObject(state, {
    products: action.products,
    productsBySku: action.products.reduce((acc, p) => ({ ...acc, [p.sku]: p }), {}),
  })
);

const setDelivery = (state, action) => (
  updateObject(state, {
    delivery: action.delivery,
  })
);

const setOrderStatus = (state, action) => (
  updateObject(state, {
    orderStatus: action.order,
  })
);

const setDermaPreview = (state, action) => (
  updateObject(state, {
    dermaPreview: action.dermaPreview,
  })
);

const reducer = createReducer(initialState, {
  [actionType.SET_PRODUCTS]: setProducts,
  [actionType.SET_DELIVERY]: setDelivery,
  [actionType.SET_ORDER_STATUS]: setOrderStatus,
  [actionType.SET_DERMA_PREVIEW]: setDermaPreview,
});

export default reducer;

// SELECTORS
export const getProducts = (state) => (
  state.products
);

export const getProductsBySku = (state) => (
  state.productsBySku
);

export const getDelivery = (state) => (
  state.delivery
);

export const getOrderStatus = (state) => (
  state.orderStatus
);

export const getDermaPreview = (state) => (
  state.dermaPreview
);
